import React from 'react';

import { Link } from '~/lib/react-router-dom';

import { Link as MuiLink } from '@mui/material';

import type { OpportunityRoomAsset } from '~/hooks/apis/offers/useGetOffer';

import { accountPath } from './accountRelatedModel';
import { useAccountOfferId } from './useAccountOfferId';

interface Props {
  accountId: string;
  asset: OpportunityRoomAsset;
}

export default function AccountAssetName({ accountId, asset }: Props) {
  const offerId = useAccountOfferId();
  const name = asset.name || asset.sfid;

  if (!asset.sfid) {
    return <>{name}</>;
  }

  return (
    <MuiLink
      component={Link}
      to={accountPath(accountId, offerId, `/assets/${asset.sfid}`)}
      underline="hover"
      variant="body2"
    >
      {name}
    </MuiLink>
  );
}
